import { parseInboundPayload } from '../inbound';
import { booleanParser, createArrayWithBracesParser, numberParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
export const UPDATE_TOURNEY_STANDINGS_INBOUND_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'activePlayers', parser: createArrayWithBracesParser(tourneyStandingsPlayerParser) },
        { name: 'finishedPlayers', parser: createArrayWithBracesParser(tourneyStandingsPlayerParser) }
    ]
};
function tourneyStandingsPlayerParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, tourneyStandingsPlayerPartDefinitions);
}
const tourneyStandingsPlayerPartDefinitions = [
    { name: 'place', parser: numberParser },
    { name: 'name', parser: stringParser },
    { name: 'id', parser: numberParser },
    { name: 'numChips', parser: numberParser },
    { name: 'isTied', parser: booleanParser }
];
